import { useSelector } from 'react-redux';
import {
  getUserLogin,
  getViewMode,
  getTempUserToken,
  getShouldDisconnectSocket,
} from 'store/auth/index';
import { getDashboardType } from 'store/global';

export const useUser = () => {
  const user = useSelector(getUserLogin);
  return user;
};

export const useViewMode = () => {
  const viewMode = useSelector(getViewMode);

  return viewMode;
};

export const useShouldDisconnectSocket = () =>
  useSelector(getShouldDisconnectSocket);

export const useTempUserToken = () => useSelector(getTempUserToken);

export const useDashboardType = () => useSelector(getDashboardType);
